/**
 * @license
 * Copyright 2025 Kai-Orion & Sandlada
 * SPDX-License-Identifier: MIT
 */

import { createStyleDefinition } from '../utils/tokens/create-style-definition'

export const IconDefinition = createStyleDefinition({
    'enabled-font': 'Material Symbols Outlined',
    'enabled-size': '24px'
})
